import PageWrapper from '@/components/page-wrapper'
import PageContainer from '@/components/container'
import RichText from '@/components/ui/rich-text'
import Video from '@/components/ui/video'
import SectionTabSection from '@/components/section/tab-section'
import SectionCta from '@/components/section/cta'
import { SetOfPricingComponent } from '@/components/section/set-of-pricing'
import { TypeResourceVideoPage } from '@/types/ctf'

type ResourcesVideoPageProps = {
  post: TypeResourceVideoPage<'WITHOUT_UNRESOLVABLE_LINKS'>
  headerNav: any
  footerNav: any
  newsletterForm: any
}

export default function ResourcesVideoPage(props: ResourcesVideoPageProps) {
  const {
    post: {
      fields: { title, video, content, extraContent, seo },
    },
    headerNav,
    footerNav,
    newsletterForm,
  } = props

  return (
    <PageWrapper seo={seo} headerNav={headerNav} footerNav={footerNav} newsletterForm={newsletterForm}>
      <div className="pt-16 pb-12 bg-indigoBlue dark:bg-secondary-900 text-white">
        <PageContainer>
          <div className="max-w-3xl mx-auto">
            {video?.fields.url && <Video {...video} />}

            <h1 className="mt-4 text-center text-2xl"> {title} </h1>
          </div>
        </PageContainer>
      </div>
      {content && (
        <PageContainer>
          <div className="max-w-2xl mx-auto py-16">
            {content.map((item, i) => (
              <RichText key={i} body={item?.fields?.body} />
            ))}
          </div>
        </PageContainer>
      )}
      {extraContent && (
        <div className="my-16">
          {extraContent.map((section) => {
            if (!section) return null
            const contentType = section.sys.contentType?.sys.id
            if (contentType === 'sectionSetOfPricing') {
              return <SetOfPricingComponent key={section.sys.id} {...section.fields} />
            }

            if (contentType === 'sectionCta') return <SectionCta key={section.sys.id} {...(section.fields as any)} />

            if (contentType === 'sectionTabSection')
              return <SectionTabSection key={section.sys.id} {...(section.fields as any)} />
            return null
          })}
        </div>
      )}
    </PageWrapper>
  )
}
